<script lang="ts">
  import { cart, cartEmail } from "../../services/cart-service";
  // import LogIntoSalesforce from './LogIntoSalesforce.svelte';
  // import { userContents } from '../../services/userInfo-service';
  // import type { UserInfo } from '../../models/user-info.interface';

  // Apparently Svelte needs this function declared "export let"
  export let postOrder = () => {}
  export let orderSubmitting: boolean;

  let email: string = $cartEmail;
  let confirmEmail: string = $cartEmail;

  // let user: UserInfo = $userContents;
  // console.log('user:,', user);

  function validateEmail(email: String) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  // Check if form is valid for submission
  $: isFormValid =
    $cart.length > 0 &&
    email !== "" &&
    confirmEmail !== "" &&
    email === confirmEmail &&
    validateEmail(email) &&
    validateEmail(confirmEmail);


  // TODO: we need to keep this but also make another function and rewrite it for legacy systems w/ correct endpoint

  //   async function postOrderOnBehalfOf(email: string) {
  //     console.log('email', email);
  //     if (email === user.email) {
  //       return postOrder();
  //     }

  //     let submitOrder = {
  //       csrEmail: user.email,
  //       email: email,
  //       orders: $cart.map((order) => {
  //         order.email = user.email;
  //         return order;
  //       })
  //     };
  //     // TODO: THIS NEEDS TO BE THE RIGHT END POINT

  //     await fetch(`${process.env.OB1_BASE_URL}/api/v2/submit`, {
  //       method: 'POST',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(submitOrder)
  //     })
  //       .then((res) => res.json())
  //       .then((o: OrderObject[]) => {
  //         cart.clear();
  //         emails.push(user.email);
  //         emails.push(email);
  //         orderComplete = o;
  //         validation = true;
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         validation = false;
  //       });
  //   }
</script>

<!-- Contact Info -->
<div class="sidebar h-100">
  <aside class="p-3">
    <!--    <LogIntoSalesforce userInfo={user}/>-->
    <!--{#if user !== null && user.csr === "True"}-->
    <h4>Contact Information</h4>
    <!-- these need to be hooked up to make ordering available -->
    <div class="mb-4">
      <label for="emailAddressInput" class="form-label pb-2">Email*</label>
      <input
        type="email"
        class="form-control"
        id="emailAddressInput"
        placeholder="Enter a valid email address"
        disabled={orderSubmitting}
        bind:value={email}
        class:is-invalid={email !== "" && !validateEmail(email)}
      />
      {#if email !== "" && !validateEmail(email)}
        <div class="invalid-feedback">Please enter a valid email address.</div>
      {/if}
    </div>
    <div>
      <label for="ConfirmEmailAddressInput" class="form-label pb-2">Confirm Email*</label>
      <input
        type="email"
        class="form-control"
        id="ConfirmEmailAddressInput"
        placeholder="Confirm email address"
        disabled={orderSubmitting}
        bind:value={confirmEmail}
        class:is-invalid={confirmEmail !== "" &&
          (email !== confirmEmail || !validateEmail(confirmEmail))}
      />
      {#if confirmEmail !== "" && email !== confirmEmail}
        <div class="invalid-feedback">Email addresses must match.</div>
      {:else if confirmEmail !== "" && !validateEmail(confirmEmail)}
        <div class="invalid-feedback">Please enter a valid email address.</div>
      {/if}
    </div>
    <div class="my-4"><small>* Denotes required field</small></div>

    <div class="d-flex justify-content-end">
      <a href="dataset-search" class="btn" style="color: grey;" role="button">
        <i class="bi bi-arrow-left"></i>
        Continue Browsing
      </a>
      <!--        <button class="btn ae-primary mx-1" type="submit" on:click={() => {postOrderOnBehalfOf(email)}}><i-->
      <!--                class="bi bi-check"></i>Submit on Behalf of-->
      <!--        </button>-->
      {#if isFormValid}
        <button
          class="btn ae-primary mx-1"
          type="submit"
          disabled={orderSubmitting}
          on:click={() => {
            //   postOrderOnBehalfOf(email);
            if (!orderSubmitting){
              $cartEmail = email;
              postOrder();
            }
          }}
          >
          {#if orderSubmitting}<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {:else}<i class="bi bi-check"></i>{/if}Submit
        </button>
      {:else}
        <button class="btn ae-primary mx-1" type="submit" disabled><i class="bi bi-check"></i>Submit</button>
      {/if}
      <!--{#if $cart.length > 0 && validateEmail(email) && user.csr === "True"}-->
      <!--  <button class="btn ae-primary mx-1" type="submit" on:click={() => {postOrderOnBehalfOf(email)}}><i-->
      <!--          class="bi bi-check"></i>Submit on Behalf of-->
      <!--  </button>-->
      <!--{:else if user.csr === "True"}-->
      <!--  <button class="btn ae-primary mx-1" type="submit" disabled><i class="bi bi-check"></i>Submit on Behalf of-->
      <!--  </button>-->
      <!--{/if}-->
    </div>
    <!--{/if}-->
  </aside>
</div>

<style>
</style>
